import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { T, LANGS } from './translations';

const LangContext = createContext(null);

const getInitialLang = () => {
  if (typeof window === 'undefined') return 'ca';
  const saved = window.localStorage.getItem('obach_lang');
  if (saved && LANGS.includes(saved)) return saved;
  const nav = (navigator.language || 'ca').slice(0, 2).toLowerCase();
  if (['es', 'en', 'fr'].includes(nav)) return nav;
  return 'ca';
};

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    window.localStorage.setItem('obach_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: T[lang] }), [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
